





















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Inject} from "vue-typedi";
import {EventBus} from "@/helpers/EventBus";
import { OrderedProduct } from '@/model/OrderedProduct';
import { OrderedProductStatuses } from '@/model/OrderedProductStatus';
import humanReadableQuantity from '@/filters/QuantityFormatter';
import RelatedOrderPanel from '@/components/products/RelatedOrderPanel.vue';
import ConfirmDialog from '@/components/dialog-box/ConfirmDialog.vue';
import { OrderedProductService } from '@/services/OrderedProductService';
import { OrderedProductsList } from '@/model/OrderedProductsList';
import { ProductService } from '@/services/ProductService';
import SnackBar from '@/components/Snackbar.vue';
import { Quantity } from '@/model/Quantity';
import { RelatedOrder } from '@/model/RelatedOrder';

@Component({
  components: {RelatedOrderPanel, ConfirmDialog, SnackBar},
  filters: {humanReadableQuantity}
})
export default class ProductPanel extends Vue {

    @Prop({default: {}}) orderedProduct: OrderedProduct;
    @Prop({default: false}) isDisplayed: boolean;
    @Prop({default: false}) canHandleSupports: boolean;

    @Inject()
    orderedProductService!: OrderedProductService;
    @Inject()
    productService!: ProductService;

    public isDialogOpen: boolean = false;
    public showSnackBar: boolean = false;
    public isOutOfStockFeatureEnabled:boolean = (window as any).config ? (window as any).config.isOutOfStockFeatureEnabled : false;

    public updateRelatedOrderStatus(orderId: string, quantityProcessed: Quantity) {
        this.orderedProductService.changeOrderedProductState(this.orderedProduct.product.cug, [orderId], OrderedProductStatuses.PREPARED, quantityProcessed)
            .then((ignored: OrderedProductsList) => {
                if(quantityProcessed.value >= this.getQuantityForOrder(orderId).value){
                    EventBus.$emit(EventBus.CHANGE_ORDERED_PRODUCT_STATE, {});
                }else{
                    this.isDialogOpen = true;
                }
            });    
    }

    public changeStatusToOutOfStock() {
        this.productService.updateProductOutOfStockStatus(this.orderedProduct.product.zoneCode, this.orderedProduct.product.cug)
            .then((ignored: any) => {
                EventBus.$emit(EventBus.UPDATE_PRODUCT_OUT_OF_STOCK_STATUS, {});
            });
    }

    public handleConfirm() {
        this.changeStatusToOutOfStock();
        this.closeDialog();
        this.openSnackBar();
    }

    public closeDialog() {
        this.isDialogOpen = false;
    }

    public toggleOrderedProductsDetailsDisplay() {
        this.$emit('clickCard', this.orderedProduct.product.cug);
    }

    openSnackBar() {
        this.showSnackBar = true;
    }

    public getQuantityForOrder(orderId: string): Quantity{
        const order: RelatedOrder = this.orderedProduct.relatedOrders.find(relatedOrder => relatedOrder.orderId == orderId);
        if(!order){
            return new Quantity();
        }
        return order.quantity;
    }

    get isFullyProcessed(): boolean {
        return this.orderedProduct.product.status === OrderedProductStatuses.PREPARED;
    }

    get productLabel(): string {
        if (this.orderedProduct.product.label == null) {
            return this.orderedProduct.product.cug
        }
        return this.orderedProduct.product.label
    }

    get codePlu(): string {
      return this.orderedProduct.product?.codePlu?.trim();
    }

    get hasCodePlu(): boolean {
        return this.orderedProduct.product?.codePlu != null && this.orderedProduct.product.codePlu.trim() !== '';
    }
}
